import { useSSRData } from 'hooks';
import { getUser } from 'utils';
import getFirstCorrectData from './utils';

const useUser = () => {
    const state = useSSRData();
    const user = getFirstCorrectData(state.user, getUser(), {});

    // eslint-disable-next-line camelcase
    user.isB2B = user.is_b2b; // quick hack for b2b until we clean that up

    return user;
};

export default useUser;
